angular.module('workflow', ['pb.core', 'components', 'ui.sortable', 'company']);
